<template>
	<div class="m-search-item flex-center" :colspan="colspan">
		<label v-if="label">{{label}}</label>
		<span v-else style="width: 12px;"></span>
		<div class="flex-grow">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mSearchItem',
		
		props: {
			label: String,
			colspan: {
				type: [String, Number],
				default: 1
			}
		}
	}
</script>

<style lang="stylus">
</style>
